<section>
  <div class="container">
    <div class="inner-container">
      <div class="header">
        <p-tag rounded severity="info" value="Actual Customer Reviews" />
        <h2>What developers say</h2>
        <p>Hear what our customers have to say about their experiences.</p>
      </div>
      <div class="carousel-container">
        <p-carousel
          [value]="reviews"
          [numVisible]="4"
          [numScroll]="1"
          circular
          [responsiveOptions]="responsiveOptions"
          autoplayInterval="3000"
        >
          <ng-template let-reviews pTemplate="item">
            <div class="review-container">
              <p>{{reviews.reviewText}}</p>
              <!--<p-rating [cancel]="false" readonly [stars]="5" [(ngModel)]="reviews.rating"/>-->
              <div class="review-bottom-bar">
                <div class="identifiable">
                  <div class="reviewer">
                    <p class="name">{{reviews.name}}</p>
                    <p class="studio">{{reviews.studio}}</p>
                  </div>
                  <div class="notable-game">
                    <p class="caption">Best Known for</p>
                    <p class="game-name">{{reviews.gameName}}</p>
                  </div>
                </div>
              </div>
            </div>
            <!--<p-rating [cancel]="false" stars="5"/>-->
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
</section>
